import { DatabaseModel, ModelJson } from './database-model';

export class PendingMember extends DatabaseModel {

    public key: string = "";
    public inviterId: string = "";
    public projectKey: string = "";
    public email: string = "";
    public createdOn: Date | any = null;
    public name: string = '';

    constructor(key: string = '', json: ModelJson = null) {
        super();
        if(json) this.fromJson(json);
        if(key) this.key = key;
    }

    /**
     * Convert database json to PendingMember instance (deserialize)
     */
    public fromJson(json: ModelJson): PendingMember {
        Object.assign(this, json);
        return this;
    }

    /**
     * Convert PendingMember instance to json (serialize)
     */
    public toJson(): ModelJson {
        let json = Object.assign({}, this);
        return json;
    }
}
